import type { SpreadReadingProfile } from "../types";

export const twoCardsReadingProfile: SpreadReadingProfile = {
  spreadId: "spread_two_cards",
  sections: [
    {
      id: "mainMeaning",
      title: "Основной смысл",
      source: { type: "keywords" },
    },
    {
      id: "questionContext",
      title: "В контексте вопроса",
      source: { type: "uprightByQuestionContext" },
    },
    {
      id: "psychology",
      title: "Психологический аспект",
      source: { type: "psychology" },
    },
  ],
};

